export const en = {
  ctaButtons: {
    request_event: 'Request a Volunteer Event',
    request_event_desc: 'Let the Purposely Team find the perfect volunteer event for you or your team!',
    create_event: 'Create a Volunteer Event',
    create_event_desc: 'Already have an event planned? You can create your own!',
  }
}